export enum RbacPermission {
  CreateProjects = 'CreateProjects',
  DraftMessaging = 'DraftMessaging',
  EmailChannel = 'EmailChannel',
  EmbeddedChannel = 'EmbeddedChannel',
  PushInAppChannel = 'PushInAppChannel',
  ManageBaseTemplates = 'ManageBaseTemplates',
  ManageBilling = 'ManageBilling',
  ManageCatalogs = 'ManageCatalogs',
  ManageChannelConfiguration = 'ManageChannelConfiguration',
  ManageIntegrations = 'ManageIntegrations',
  ManageMembers = 'ManageMembers',
  ManageMessaging = 'ManageMessaging',
  ManagePredictiveGoals = 'ManagePredictiveGoals',
  ManageProjectSettings = 'ManageProjectSettings',
  ManageReports = 'ManageReports',
  ManageRoles = 'ManageRoles',
  ManageSegmentation = 'ManageSegmentation',
  ManageSnippets = 'ManageSnippets',
  ManageUserProfiles = 'ManageUserProfiles',
  PushChannel = 'PushChannel',
  SMSChannel = 'SMSChannel',
  ViewAndExportUserData = 'ViewAndExportUserData',
  ViewCatalogs = 'ViewCatalogs',
  ViewChannelConfiguration = 'ViewChannelConfiguration',
  ViewMessaging = 'ViewMessaging',
  ViewPredictiveGoals = 'ViewPredictiveGoals',
  ViewReports = 'ViewReports',
  PushWebChannel = 'PushWebChannel',
}
